import React, { FC } from 'react';
import { useStore } from '@/app/providers/StoreProvider';
import { observer } from 'mobx-react-lite';
import { TeamItem } from './TeamItem';
import { LoadingSearch } from '@/shared/ui/LoadingSearch';


export const SearchTeamsList:FC = observer(() => {
  const {teamStore} = useStore();
  const {search,searchTeams, loadingSearchTeams} = teamStore;
  if(loadingSearchTeams) return <LoadingSearch/>
  return (
        searchTeams.length > 0
        ? 
        <div className='search-teams_list'>
          {searchTeams.map((team)=>(
            <TeamItem team={team} key={team.id.replace(/\D/g, '')}/>
          ))}
        </div>
        : 
        search&&
        <div className='search-teams_empty'>
            <h3 className='search-teams_title'>К сожалению по данному запросу<br/> ничего не найдено</h3>
            <p className='search-teams_text'>Попробуйте еще раз или измените данные</p>
        </div>
  );

});